export default __webpack_public_path__ + "static/media/1415.72b341f5.png";